<template>
	<div>
		<header class="flex gap-2 content-between item-center">
			<h1 class="alpha heavy">Leads</h1>
			<ul>
				<li v-if="$can('quote.create')"><router-link
					:to="{name: 'quotes.create'}"
					class="button button--primary--small">New Quote</router-link></li>
			</ul>
		</header>
		<v-tabs :update-hash="true" class="tabs--buttons section--floating section--expanded">
			<v-tab id="all" label="All">
				<VStoreTable :links="tableLinks" :show-download="true" store-name="leads"/>
			</v-tab>
			<v-tab id="new" label="New">
				<div class="filter-age">
					<p>Age (days)</p>
					<ul>
						<li>28</li>
						<li>21</li>
						<li>14</li>
						<li>7</li>
						<li>5</li>
						<li>3</li>
					</ul>
				</div>
			</v-tab>
			<v-tab id="potential" label="Potential">
				<div class="filter-age">
					<p>Age (days)</p>
					<ul>
						<li>28</li>
						<li>21</li>
						<li>14</li>
						<li>7</li>
						<li>5</li>
						<li>3</li>
					</ul>
				</div>
			</v-tab>
			<v-tab id="inactive" label="Inactive">
				<div class="filter-age">
					<p>Age (days)</p>
					<ul>
						<li>28</li>
						<li>21</li>
						<li>14</li>
						<li>7</li>
						<li>5</li>
						<li>3</li>
					</ul>
				</div>
			</v-tab>
		</v-tabs>
	</div>
</template>
<script>
// import download from "@/apps/portal/components/modals/Download.vue";
import VStoreTable from "@/common/components/v-table/v-store-table.vue";
import TagList from "../../../../common/components/TagList";
import Index from "../../../../components";

let index = new Index("leads");

export default {
	components: {
		TagList,
		VStoreTable,
	},

	computed: {
		// download() {
		// 	return download;
		// },
		// ...index.computed(),
		tableLinks() {
			return {
				"client.name": (data, column) => this.getClientRoute(data),
			};
		},
	},

	methods: {
		// ...index.actions(),
		getClientRoute(lead) {
			return {
				name: "clients.show",
				params: {
					client: lead.client.id,
				},
				hash: lead.instruction ? "#cases" : "#leads",
			};
		},
		toggleTag(lead, tag) {
			http().patch(this.route("leads/:lead/tags/:tag", [lead, tag])).then(response => {
				this.replaceModel(response.data.data);
			});
		},
	},
};
</script>
